<template>
  <div class="hud">
    <div class="paddingRound">
      <h2>
        <i class="fas fa-heart"></i>
      </h2>
    </div>
  <progress-bar-step :value="hp*10" :hue="350" :withoutColor="true"></progress-bar-step>
    <!--<progress-bar class="hpBar" :style="styleObject"
        :options="options"
        :value="hp"></progress-bar>-->
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
name: "hpHUD",

  components: {
    ProgressBarStep: () => import(/* webpackPrefetch: true */ '@/components/progressBarStep.vue'),
    // ProgressBar
  },

  props: {
    hp: Number
  },

  created() {
    if(this.isMobile) {
      this.HPwidth = 100;
      this.HPheight = 15;

    }
  },

  methods: {

  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    styleObject() {
      return {
        '--HPwidth': this.HPwidth + 'px',
        '--HPheight': this.HPheight + 'px'
      }
    },

    options: function() {
      return {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: true
        },
        progress: {
          color: '#d44337',
          backgroundColor: '#000000',
          inverted: false
        },
        layout: {
          height: this.HPheight,
          width: this.HPwidth,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },

  data() {
    return {
      HPwidth: 400,
      HPheight: 45,
    }
  }
}
</script>

<style scoped>
  .hud {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: hsla(190,0%,100%,1);
    width: 50%;
    font-size: 2vw;
  }

  .hpBar {
    width: var(--HPwidth);
    height: var(--HPheight);
    border: 2px solid whitesmoke;
  }

  @media screen and (max-device-width: 767px) {
    .hud {
      width: 90%;
    }
  }
</style>